import React from 'react';
import c from 'classnames';
import BiButton from '@wix/da-bi/pkg/Components/BiButton';
import s from './SocialButtonIconViewBase.scss';
var SocialButtonIconViewBase = function (_a) {
    var biData = _a.biData, className = _a.className, onClick = _a.onClick, children = _a.children;
    return (React.createElement(BiButton, { className: c(s['root'], className), biData: biData, onClick: onClick }));
};
SocialButtonIconViewBase.displayName = 'SocialButtonIconViewBase';
export default SocialButtonIconViewBase;
//# sourceMappingURL=SocialButtonIconViewBase.js.map